import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuizState, Quiz, QuizResult } from '../types';

const initialState: QuizState = {
  currentQuiz: null,
  currentQuestionIndex: 0,
  answers: {},
  loading: false,
  error: null,
  result: null,
};

const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    setQuiz: (state, action: PayloadAction<Quiz>) => {
      state.currentQuiz = action.payload;
      state.currentQuestionIndex = 0;
      state.answers = {};
      state.error = null;
      state.result = null;
    },
    setQuestionIndex: (state, action: PayloadAction<number>) => {
      state.currentQuestionIndex = action.payload;
    },
    setAnswer: (state, action: PayloadAction<{ questionId: string; answerIndex: number }>) => {
      state.answers[action.payload.questionId] = action.payload.answerIndex;
    },
    setResult: (state, action: PayloadAction<QuizResult>) => {
      state.result = action.payload;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearQuiz: (state) => {
      state.currentQuiz = null;
      state.currentQuestionIndex = 0;
      state.answers = {};
      state.result = null;
      state.error = null;
    },
  },
});

export const {
  setQuiz,
  setQuestionIndex,
  setAnswer,
  setResult,
  setLoading,
  setError,
  clearQuiz,
} = quizSlice.actions;
export default quizSlice.reducer;

